import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from 'linaria';
import { Gallery, Section, SectionSubTitle } from 'common/components';
import { WINDOWS_ELEMENT_BLOCK } from '../../windows-constants';
import { IMAGE_PER_PAGE, getWindowsProjectGalleryList } from './windows-project-gallery-section-constants';

type WindowsInteriorGallerySectionProps = {
  onConsultationSignupBtnClick: () => void;
};

const windowsProjectTitle = css`
  @media (--only-largeDesktop) {
    width: 776px;
  }

  @media (--only-desktop) {
    width: 574px;
  }
`;

export const WindowsProjectGallerySection = memo(
  ({ onConsultationSignupBtnClick }: WindowsInteriorGallerySectionProps) => {
    const { t } = useTranslation();

    return (
      <Section>
        <SectionSubTitle className={windowsProjectTitle} margin="m">
          {t('project-gallery-section.title')}
        </SectionSubTitle>
        <Gallery
          elementBlock={`${WINDOWS_ELEMENT_BLOCK}_flat`}
          elementText="Выполненные проекты"
          imageList={getWindowsProjectGalleryList(t)}
          imagePerPage={IMAGE_PER_PAGE}
          isShowImageName
          modalBtnProps={{
            onClick: onConsultationSignupBtnClick,
          }}
          promoElementBlock={`${WINDOWS_ELEMENT_BLOCK} / flat`}
          showMoreBtnLabel={t('project-gallery-section.more-button') || ''}
          modalBtnLabel={t('design-panel.button') || ''}
        />
      </Section>
    )
  }
);
